export default __webpack_public_path__ + "static/media/IconDesc_PackagedNitricAcid.256.46414b87.png";